<div class="horizontal w-100 flex-wrap">
  <mat-form-field class="country-code">
    <input matInput placeholder="Ländercode" [(ngModel)]="innerValue.countryCode" />
  </mat-form-field>

  <mat-form-field class="phone-number">
    <input matInput placeholder="Nummer" [(ngModel)]="innerValue.phoneNumber" />
  </mat-form-field>
</div>
